const backendConfig = {
  // Base URL for the backend API
  // Update this to your actual backend URL when deployed
  API_BASE_URL: process.env.REACT_APP_BACKEND_URL,

  // API endpoints
  ENDPOINTS: {
    ADMIN: "/admin",
    CATEGORIES: "/categories",
    PRODUCTS: "/products",
    ORDERS: "/orders",
    REVIEWS: "/reviews",
    STATS: "/stats",
    UPLOAD: "/upload",
  },
};

export default backendConfig;
